import { iconSize, IconSizeProps } from '@/types/icons';

export const IconXCircle = ({ size }: IconSizeProps) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <path
        d="M16.0003 2.66666C8.62699 2.66666 2.66699 8.62666 2.66699 16C2.66699 23.3733 8.62699 29.3333 16.0003 29.3333C23.3737 29.3333 29.3337 23.3733 29.3337 16C29.3337 8.62666 23.3737 2.66666 16.0003 2.66666ZM21.7337 21.7333C21.6103 21.8569 21.4638 21.955 21.3025 22.0219C21.1412 22.0888 20.9683 22.1233 20.7937 22.1233C20.619 22.1233 20.4461 22.0888 20.2848 22.0219C20.1235 21.955 19.977 21.8569 19.8537 21.7333L16.0003 17.88L12.147 21.7333C11.8977 21.9826 11.5596 22.1227 11.207 22.1227C10.8544 22.1227 10.5163 21.9826 10.267 21.7333C10.0177 21.484 9.87763 21.1459 9.87763 20.7933C9.87763 20.6188 9.91202 20.4459 9.97882 20.2846C10.0456 20.1233 10.1435 19.9768 10.267 19.8533L14.1203 16L10.267 12.1467C10.0177 11.8974 9.87763 11.5592 9.87763 11.2067C9.87763 10.8541 10.0177 10.516 10.267 10.2667C10.5163 10.0174 10.8544 9.8773 11.207 9.8773C11.5596 9.8773 11.8977 10.0174 12.147 10.2667L16.0003 14.12L19.8537 10.2667C19.9771 10.1432 20.1236 10.0453 20.2849 9.97849C20.4462 9.91169 20.6191 9.8773 20.7937 9.8773C20.9682 9.8773 21.1411 9.91169 21.3024 9.97849C21.4637 10.0453 21.6102 10.1432 21.7337 10.2667C21.8571 10.3901 21.955 10.5367 22.0218 10.6979C22.0886 10.8592 22.123 11.0321 22.123 11.2067C22.123 11.3812 22.0886 11.5541 22.0218 11.7154C21.955 11.8767 21.8571 12.0232 21.7337 12.1467L17.8803 16L21.7337 19.8533C22.2403 20.36 22.2403 21.2133 21.7337 21.7333Z"
        fill="#505050"
      />
    </svg>
  );
};
